import React from "react";
import { FiBook, FiAlertCircle, FiLoader } from "react-icons/fi";

export default function VocabularyStep({
  NavigationButtons,
  vocabularyGeneration,
  vocabularyDisplayRowsOrdered,
  vocabularyRows,
  vocabularyChangedCount,
  vocabularyUnchangedCount,
  vocabularySourceRowsForDisplay,
  vocabularyVaultRowsForDisplay,
  vocabularySourceRowsById,
  renderDocumentStyleSurface,
  renderVocabularyDiffText,
}) {
  const vocabularyTotal = vocabularyGeneration.totalRows || vocabularyRows.length || 0;
  const vocabularyGenerated = Math.min(vocabularyGeneration.generatedRows || 0, vocabularyTotal || vocabularyGeneration.generatedRows || 0);
  const vocabularyProgress = vocabularyTotal > 0
    ? Math.round((vocabularyGenerated / vocabularyTotal) * 100)
    : (vocabularyGeneration.running ? 0 : 100);
  const showPageLoader = vocabularyGeneration.running && vocabularyGenerated <= 0;

  return (
    <div className="wizard-step-content">
      {showPageLoader && (
        <div className="vault-api-loader-overlay" role="status" aria-live="polite" aria-label="Generating Content In Progress">
          <div className="vault-api-loader-card">
            <span className="vault-api-loader-spinner spinner" />
            <span className="vault-api-loader-text">Generating Content - In Progress</span>
          </div>
        </div>
      )}
      <div className="step-header-with-nav">
        <div className="step-header-left">
          <div className="step-icon-wrapper">
            <FiBook className="step-icon" />
          </div>
          <div className="step-header-text">
            <h2 className="step-title">Process - Vocabulary Enhancement</h2>
            <p className="step-subtitle">Veeva Content - Original vs Vault Vocabulary Enhanced Content</p>
          </div>
        </div>
        <NavigationButtons />
      </div>

      <div className="form-section">
        {(vocabularyGeneration.running || vocabularyDisplayRowsOrdered.length > 0) && (
          <div className={`process-progress-card${vocabularyGeneration.running ? " running" : ""}`} role="status">
            <div className="process-progress-header">
              <span className="process-progress-title">
                {vocabularyGeneration.running ? (
                  <>
                    <FiLoader className="spinner" /> Generating Content - In Progress
                  </>
                ) : (
                  "Generating Content - Complete"
                )}
              </span>
              <span className="process-progress-count">
                {vocabularyGenerated}/{vocabularyTotal || 0}
              </span>
            </div>
            <div className="process-progress-track" aria-hidden="true">
              <div
                className={`process-progress-fill${vocabularyGeneration.running ? " is-running" : ""}`}
                style={{
                  width: `${Math.min(100, Math.max(0, vocabularyProgress))}%`,
                }}
              />
            </div>
          </div>
        )}

        {vocabularyDisplayRowsOrdered.length > 0 && !vocabularyGeneration.running && (
          <div className="vocabulary-summary">
            <span>
              Rows changed by vocabulary enhancement: {vocabularyChangedCount}/{vocabularyRows.length || vocabularyDisplayRowsOrdered.length}
              {` `}
              (unchanged: {vocabularyUnchangedCount})
            </span>
          </div>
        )}

        {vocabularyDisplayRowsOrdered.length === 0 ? (
          <div className="reference-note" role="status">
            <FiAlertCircle className="note-icon" />
            <p>No process rows found. Complete Process generation first.</p>
          </div>
        ) : (
          <div className="process-document-compare-scroll">
            <div className="process-document-compare-grid">
              <div className="process-document-panel">
                <div className="process-document-panel-title">Veeva Content - Original</div>
                {renderDocumentStyleSurface(vocabularySourceRowsForDisplay, "vocabulary-source")}
              </div>
              <div className="process-document-panel">
                <div className="process-document-panel-title">Vault Content - Vocabulary Enhanced</div>
                {renderDocumentStyleSurface(vocabularyVaultRowsForDisplay, "vocabulary-vault", {
                  diffBaseRowsById: vocabularySourceRowsById,
                  enableDiffHighlight: true,
                  diffRenderer: renderVocabularyDiffText,
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
